import {
  FETCH_CURRENT_USER, 
  UPDATE_CURRENT_USER,

} from "./types";
import {simpleRequest} from "../newForms2/simpleRequest"

export function fetchCurrentUserFromApi(username) {
  return async function (dispatch) {
    const response = await simpleRequest({url:`users/${username}`, method:"get"});
    const user=response.data?.user || {};
    return dispatch(getCurrentUser(user));
  };
}

function getCurrentUser(currentUser) {
  return {
    type: FETCH_CURRENT_USER,
    currentUser,
  };
}

export function updateCurrentUserOnAPI(username, data){
  return async function(dispatch){
    const response = await simpleRequest({url:`users/${username}`, method:"patch", data});
    const updated = response.data && response.data.updated
    if(!updated)return;
    return dispatch(updateCurrentUser(updated));
  };
}

function updateCurrentUser(updated){
  return {
    type: UPDATE_CURRENT_USER,
    updated
  };
};




